// Signal / gate color + label helpers

export const ACTION_STYLE = {
  LONG: "text-bull border-bull/40 bg-bull/10",
  BUY: "text-bull border-bull/40 bg-bull/10",
  SHORT: "text-bear border-bear/40 bg-bear/10",
  SELL: "text-bear border-bear/40 bg-bear/10",
  HOLD: "text-neutral border-neutral/40 bg-neutral/10",
  WATCH: "text-sky-400 border-sky-400/40 bg-sky-400/10",
  EXIT: "text-bear border-bear/40 bg-bear/10",
  AVOID: "text-muted-foreground border-border bg-muted",
};

export function actionStyle(a) {
  return ACTION_STYLE[(a || "").toUpperCase()] || ACTION_STYLE.AVOID;
}

const POSITIVE = ["READY", "OPEN", "RISK_ON", "LEADING", "ACCUMULATION", "OK", "BULLISH", "F&O ELIGIBLE"];
const NEGATIVE = ["NOT_READY", "CLOSED", "RISK_OFF", "LAGGING", "DISTRIBUTION", "LOW", "ILLIQUID", "BEARISH"];

export function gateColor(v) {
  const s = String(v).toUpperCase();
  if (POSITIVE.includes(s)) return "text-bull";
  if (NEGATIVE.includes(s)) return "text-bear";
  return "text-neutral";
}

export function stateColor(s) {
  if (s === "BULLISH") return "text-bull";
  if (s === "BEARISH") return "text-bear";
  return "text-muted-foreground";
}

export function fmt(n, d = 2) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return Number(n).toLocaleString(undefined, { minimumFractionDigits: d, maximumFractionDigits: d });
}

export function confColor(s) {
  if (s >= 60) return "text-bull";
  if (s >= 35) return "text-neutral";
  return "text-muted-foreground";
}

export function fmtTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
}
